import React from "react";
import { Alert } from "antd";
import { useTranslation } from "react-i18next";

const OfflinePaymentInfoAlert = () => {
  const { t } = useTranslation();
  return (
    <div style={{ marginTop: 10 }}>
      <Alert
        className="offline-payment-info"
        message={
          <div className="content">
            {t("offlinePayment.message")}
          </div>
        }
        type="info"
      />
    </div>
  );
};

export default OfflinePaymentInfoAlert;
